__webpack_require__.p = "https://static.cozytaps.com/wise-sayings/";